import React from 'react';
import { Card, CardContent, Container, Typography } from '@material-ui/core';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';

import { useStyles } from './ServiceError.styles';
import { useTranslation } from 'react-i18next';

function ServiceError() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <svg
          width="1600"
          height="505"
          viewBox="0 0 1400 505"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          transform="translate(0,150)"
        >
          <path
            d="M-1107.23 216.827C-953.576 284.863 -768.043 275.088 -622.084 192.553C-535.33 143.007 -462.074 69.4837 -367.99 30.8179C-265.509 -11.1003 -153.247 -5.84831 -45.8054 25.4301C10.9784 41.969 66.4341 65.7088 118.118 93.0228C167.842 119.274 216.415 149.233 264.472 178.99C326.522 217.776 388.47 256.819 454.198 286.946C490.49 303.497 527.888 317.215 566.337 327.483C630.209 344.118 694.87 350.373 759.169 349.954C861.932 349.12 966.252 331.376 1072.42 313.464C1177.26 295.922 1282.35 278.48 1386.33 269.214C1479.48 261.062 1572.38 259.641 1665.38 271.623C1677.82 273.217 1690.17 275.069 1702.66 277.278C1759.09 287.143 1814.44 304.31 1859.18 337.227C1913.9 377.305 1948.45 445.434 1930.85 504.176"
            stroke="#C3C6FF"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>
        <svg
          width="689"
          height="672"
          viewBox="0 0 689 672"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          transform="translate(850,-520)"
        >
          <path
            d="M838.534 1942.09C849.444 1882.32 864.733 1799.21 896.88 1715.38C929.012 1631 974.16 1547.12 1021.87 1465.93C1033.8 1445.71 1045.99 1425.2 1058.21 1405.24C1094.56 1345.1 1131.74 1284.93 1159.12 1220.04C1162.24 1212.49 1165.37 1204.94 1168.22 1197.4C1198.51 1116.66 1210.91 1028.92 1198.8 945.402C1182.63 832.941 1126.19 736.179 1054.01 651.442C970.711 553.713 858.142 468.91 754.316 401.311C707.603 370.698 663.797 345.543 621.02 328.108C558.946 302.594 485.998 284.553 455.251 207.879C438.977 166.799 442.445 118.847 453.195 74.3047C457.453 57.042 462.563 40.5874 468.537 25.4938C490.096 -29.0104 518.007 -73.165 533.605 -122.812C547.154 -166.044 550.232 -218.412 526.132 -262.611C522.359 -269.43 518.042 -275.959 513.178 -282.197C468.567 -338.594 383.533 -353.28 310.147 -356.094C256.979 -358.045 202.5 -357.195 152.337 -371.396C132.827 -376.98 113.814 -384.791 96.097 -395.954C28.3213 -438.751 -6.297 -526.115 2.44913 -605.466C11.1881 -685.093 60.9244 -751.942 119.921 -802.984C194.065 -867.419 295.908 -909.051 399.379 -908.949"
            stroke="white"
            strokeOpacity="0.3"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>
        <svg width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg" transform="translate(825,-1185)">
          <path
            d="M0.97855 -654.773C-2.1645 -486.758 78.7752 -319.525 211.443 -216.98C290.748 -156.22 386.922 -117.198 459.039 -45.4628C537.41 32.751 576.092 138.27 588.914 249.434C595.684 308.189 595.301 368.511 590.16 426.742C585.24 482.755 576.456 539.143 567.657 594.979C555.961 667.212 543.989 739.452 541.7 811.72C540.514 851.59 542.368 891.381 547.81 930.804C557.238 996.13 576.542 1058.16 601.856 1117.27C642.465 1211.67 699.265 1300.95 756.937 1391.87C813.752 1481.71 870.573 1571.82 919.427 1664.07C963.055 1746.78 1000.38 1831.86 1025.39 1922.23C1028.75 1934.32 1031.83 1946.41 1034.63 1958.79C1047.42 2014.63 1053.05 2072.3 1040.06 2126.31C1024.32 2192.28 974.921 2250.55 913.949 2257.1"
            stroke="#C3C6FF"
            strokeWidth="0.9463"
            strokeMiterlimit="10"
          />
        </svg>
        <Card className={classes.root}>
          <CardContent>
            <SentimentVeryDissatisfiedIcon className={classes.icon} />
            <Typography className={classes.header}>Bardzo przepraszamy</Typography>
            <Typography className={classes.text1}>
              Właśnie trwają planowane prace serwisowe w systemie i korzystanie z aplikacji {t('global:shortNames.system')} nie jest możliwe.
            </Typography>
            <Typography className={classes.text2}>Serdecznie zapraszamy ponownie</Typography>
            <Typography className={classes.text2}>w poniedziałek 12 czerwca 2023.</Typography>
          </CardContent>
        </Card>
      </div>
    </Container>
  );
}

export default ServiceError;
